import { Routes, Route, Navigate } from 'react-router-dom';

import useToken from '../../common/hooks/useToken';
import useUserName from '../../common/hooks/useUserName';
import usePcode from '../../common/hooks/usePcode';
import useUserMode from '../../common/hooks/useUserMode';

import MainMenu from './mainMenu';

import LogIn from '../../components/logIn';
import { useEffect, useRef } from 'react';

export default function Room() {
    const { token, setToken } = useToken();
    const { setLogedUserName } = useUserName();
    const { setLoggedPCode } = usePcode();
    const { userMode, setLogedUserMode } = useUserMode();

    const isMount = useRef(false);

    useEffect(() => {
        if (isMount.current === false) {
            isMount.current = true;

            if (userMode !== null && userMode !== undefined && !userMode.startsWith("Room"))
                logOut();
        }
    },[])

    const logOut = () => {
        setToken('');
        setLogedUserName('');
        setLoggedPCode('');
        setLogedUserMode('');
    }

    if (!token)
        return <LogIn setToken={setToken} setLogedUserName={setLogedUserName} setLoggedPcode={setLoggedPCode} logInType={'Room'} logInTitle={"Room"}
            userNamePlaceHolder={'Room #'} setLogedUserMode={setLogedUserMode} />;

    return (
        <Routes>
            <Route path={'*'} element={<Navigate to={'mainmenu'} />}></Route>
            <Route path={'mainMenu'} element={<MainMenu logOut={logOut} />}></Route>
        </Routes>
    )
}